var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-answer"},[_c('img',{staticClass:"user-logo",attrs:{"src":require("../../assets/img/logo.jpeg")}}),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('div',{staticClass:"right"})])])}
var staticRenderFns = []

export { render, staticRenderFns }